/* MTP PHOTO — isolated rendering adapter, 2026-09-20.
 * Source: product-v9/live-theme/assets/mtp-guided-engine.js, live theme
 * 203743232340. Ported drawing contracts: photos/bounds (lines 10–26),
 * sizeCqwFor (166), buildCleanHex (236–265), text/Bezier (339–382),
 * paintEngraveLive/renderTileTo (430–602), holes (608–629), font weights
 * (679–724). Only rendering is copied. There is no MTP form, cart, analytics,
 * observer, document-wide selector, catalogue request or expert bootstrap.
 * Load ONLY from product.photo-gravee; no classic theme asset is changed.
 *
 * Coordinates/size/rotation and the engraving colour match live MTP. Glyphs
 * and drawings keep their natural ratio in physical millimetres, then both
 * axes are projected onto the photographed face (no artificial blank band).
 * Production cropping remains the responsibility of PhotoCrop; this
 * painter never simplifies paths, modifies a recipe, or generates a laser SVG.
 * Ready rejects missing resources instead of silently changing fonts/artwork.
 *
 * const r = PhotoRenderer.create();
 * await r.ready(recipe);
 * await r.render(canvas, recipe, {width:600,height:600,dpr:2});
 * const dataURL = await r.png(recipe,{width:1200,height:1200});
 * render returns face in logical pixels, plus facePixels in canvas pixels.
 */
(function(root){'use strict';
const PHOTOS={
 hexa:{url:'https://cdn.shopify.com/s/files/1/1039/8665/9668/files/file_00000000fec87243a998a236f69b846b.webp?v=1782338066',box:{x0:.0726,y0:.0909,x1:.9306,y1:.8628}},
 carree:{url:'https://cdn.shopify.com/s/files/1/1039/8665/9668/files/file_0000000095b071f48d1938042d6500fb.webp?v=1782929936',box:{x0:.0583,y0:.0575,x1:.9333,y1:.9325}}
};
const FONTS={
 allura:{family:'Photo Allura',canonical:'Allura',weights:'400',source:'google',category:'manu'},
 cormorant:{family:'Photo Cormorant',canonical:'Cormorant Garamond',weights:'300;400;500;600;700',source:'google',category:'eleg'},
 dmsans:{family:'Photo DM Sans',canonical:'DM Sans',weights:'100;200;300;400;500;600;700;800;900',source:'google',category:'mod'}
};
const fontLoads=new Map();
const shapeOf=r=>r.shape==='carree'?'carree':'hexa';
const dimensions=shape=>shape==='carree'?{width:130,height:130}:{width:120,height:100};
const finite=(v,f)=>Number.isFinite(Number(v))?Number(v):f;
const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
function normRot(r){r=Math.round(+r||0)%360;if(r>180)r-=360;if(r<-180)r+=360;if(Math.abs(r)<4)r=0;return r;}
function requestedWeight(e,f){return Number(e.weight)||(f.category==='manu'?400:600);}
function nearestWeight(f,w){
 const list=(String(f.weights||'400').match(/\d+/g)||['400']).map(Number);
 return list.reduce((best,v)=>Math.abs(v-w)<Math.abs(best-w)?v:best,list[0]);
}
function fontsourceWoff(family,weight){const slug=family.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');return 'https://cdn.jsdelivr.net/npm/@fontsource/'+slug+'@5/files/'+slug+'-latin-'+weight+'-normal.woff';}
function syntheticStroke(weight,faceWeight,size){return Math.max(0,weight-faceWeight)*size*.055/400;}
function contain(iw,ih,W,H){const k=Math.min(W/iw,H/ih),w=iw*k,h=ih*k;return {x:(W-w)/2,y:(H-h)/2,width:w,height:h};}
function geometry(shape,W,H,options={}){
 const physical=dimensions(shape),p=PHOTOS[shape==='carree'?'carree':'hexa'],box=options.box||p.box;
 const image=contain(options.imageWidth||1,options.imageHeight||1,W,H);
 const face=options.mode==='face'?contain(physical.width,physical.height,W,H):{x:image.x+box.x0*image.width,y:image.y+box.y0*image.height,width:(box.x1-box.x0)*image.width,height:(box.y1-box.y0)*image.height};
 return {physical,image,face};
}
function canvas(W,H){const c=document.createElement('canvas');c.width=Math.max(1,Math.round(W));c.height=Math.max(1,Math.round(H));return c;}
function quality(ctx){ctx.imageSmoothingEnabled=true;try{ctx.imageSmoothingQuality='high';}catch{}}
function image(url,timeout=15000){return new Promise((resolve,reject)=>{
 const im=new Image();let timer=setTimeout(()=>finish(Error('Une image de l’aperçu ne répond pas.')),timeout);
 function finish(error){if(!timer)return;clearTimeout(timer);timer=null;im.onload=im.onerror=null;error?reject(error):resolve(im);}
 im.crossOrigin='anonymous';im.onload=()=>finish();im.onerror=()=>finish(Error('Une image de l’aperçu est indisponible.'));im.src=url;
});}
function viewBox(svg){const m=String(svg).match(/\bviewBox\s*=\s*["']([^"']+)["']/i),v=m&&m[1].trim().split(/[\s,]+/).map(Number);if(!v||v.length!==4||!v.every(Number.isFinite)||v[2]<=0||v[3]<=0)throw Error('Le dessin ne possède pas de dimensions valides.');return v;}
function inkSvg(raw){
 // Generated files contain paths only. A small vector allowlist also accepts
 // safe inline catalogue logos, while keeping all external resources out of
 // a canvas that will be exported for the cart.
 const doc=new DOMParser().parseFromString(String(raw),'image/svg+xml');
 if(doc.querySelector('parsererror')||doc.documentElement.localName!=='svg')throw Error('Le dessin SVG est illisible.');
 const allowed=new Set(['svg','g','path','rect','circle','ellipse','polygon','polyline','line','defs','clipPath','title','desc']);
 for(const n of Array.from(doc.querySelectorAll('*'))){
  if(!allowed.has(n.localName))throw Error('Le dessin contient un élément non pris en charge : '+n.localName+'.');
  for(const a of Array.from(n.attributes)){
   if(/^on/i.test(a.name)||['href','xlink:href','style','class','filter','mask'].includes(a.name))throw Error('Le dessin doit être un SVG autonome sans ressources externes.');
   if(/url\(/i.test(a.value)&&!/^url\(\s*#[\w-]+\s*\)$/.test(a.value))throw Error('Une ressource externe est interdite dans le dessin.');
   if(['fill','stroke'].includes(a.name)&&!['none','transparent'].includes(a.value.toLowerCase()))n.setAttribute(a.name,'#000');
  }
 }
 const svg=doc.documentElement,v=viewBox(raw);svg.setAttribute('xmlns','http://www.w3.org/2000/svg');svg.setAttribute('width',v[2]);svg.setAttribute('height',v[3]);if(!svg.hasAttribute('fill'))svg.setAttribute('fill','#000');svg.setAttribute('color','#000');
 return {svg:new XMLSerializer().serializeToString(svg),viewBox:v};
}
function shapePath(ctx,shape,W,H){
 ctx.beginPath();if(shape==='hexa'){ctx.moveTo(W*.25,0);ctx.lineTo(W*.75,0);ctx.lineTo(W,H*.5);ctx.lineTo(W*.75,H);ctx.lineTo(W*.25,H);ctx.lineTo(0,H*.5);}
 else{const r=W*.03;ctx.moveTo(r,0);ctx.arcTo(W,0,W,H,r);ctx.arcTo(W,H,0,H,r);ctx.arcTo(0,H,0,0,r);ctx.arcTo(0,0,W,0,r);}ctx.closePath();
}
// Literal MTP Bezier evaluator, retained for exact numerical parity.
function _arcLayout(widths,total,fs,cv){
 var aw=Math.max(total*1.12,fs*3),d=(cv>0)?1:-1,sag=Math.abs(cv)*aw*0.42;
 var P0x=-aw/2,P2x=aw/2,P1y=2*(-d*sag);
 function bez(t){var mt=1-t;return {x:mt*mt*P0x+t*t*P2x,y:2*mt*t*P1y};}
 function dbez(t){var mt=1-t;return {x:2*mt*(0-P0x)+2*t*(P2x-0),y:2*mt*P1y+2*t*(-P1y)};}
 var N=160,acc=[0],prev=bez(0),k;
 for(k=1;k<=N;k++){var p=bez(k/N);acc.push(acc[k-1]+Math.hypot(p.x-prev.x,p.y-prev.y));prev=p;}
 var aL=acc[N];
 function tAt(L){L=Math.max(0,Math.min(aL,L));for(var q=1;q<=N;q++){if(acc[q]>=L){var l0=acc[q-1],l1=acc[q],f=(l1>l0)?(L-l0)/(l1-l0):0;return (q-1+f)/N;}}return 1;}
 var run=(aL-total)/2,out=[];
 for(var i=0;i<widths.length;i++){var wc=widths[i],t=tAt(run+wc/2),pp=bez(t),dd=dbez(t);out.push({x:pp.x,y:pp.y,a:Math.atan2(dd.y,dd.x)});run+=wc;}
 return out;
}
function arcLayout(widths,fs,curve){const total=widths.reduce((a,b)=>a+b,0);return total>0?_arcLayout(widths,total,fs,clamp(curve,-100,100)/100):[];}
function cssFont(f,weight,size){return weight+' '+size+'px '+JSON.stringify(f.family);}
function fontDef(e,recipe,options){
 const supplied=options.fonts?.[e.font],specific=(recipe.fonts||[]).find(f=>f.id===e.font),known=FONTS[e.font];
 const f={...known,...(specific?.source==='alias'?{}:specific),...(typeof supplied==='string'?{family:supplied}:supplied)};
 if(!f.family)throw Error('Police non configurée : '+e.font+'.');
 const weight=requestedWeight(e,f),faceWeight=nearestWeight(f,weight);
 const url=f.source==='google'?fontsourceWoff(f.canonical||f.family,faceWeight):f.ttf||f.laser||f.otf||f.url;
 return {...f,url,weight,faceWeight};
}
function loadFont(f,timeout=15000){
 const key=[f.family,f.url||'',f.faceWeight].join('|');if(fontLoads.has(key))return fontLoads.get(key);
 const work=(async()=>{
  if(!document.fonts)throw Error('Ce navigateur ne peut pas charger les polices de gravure.');
  const query=cssFont(f,f.faceWeight,24);
  // Honour the studio's already declared faces, so measuring a caption and
  // painting it cannot use two different versions of the font.
  let timer;const limit=new Promise((_,reject)=>{timer=setTimeout(()=>reject(Error('La police '+f.family+' ne répond pas.')),timeout);});
  try{await Promise.race([(async()=>{
   const existing=await document.fonts.load(query);if(existing.some(face=>face.family.replace(/["']/g,'')===f.family&&String(face.weight)===String(f.faceWeight)))return;
   if(!f.url)throw Error('La police '+f.family+' n’est pas prête.');
   const face=new FontFace(f.family,'url('+JSON.stringify(f.url)+')',{weight:String(f.faceWeight),style:'normal'});
   await face.load();document.fonts.add(face);await document.fonts.load(query);
  })(),limit]);}finally{clearTimeout(timer);}return true;
 })().catch(error=>{fontLoads.delete(key);throw error;});fontLoads.set(key,work);return work;
}
function drawText(ctx,e,f,fs){
 const text=e.smallcaps?String(e.text||'').toUpperCase():String(e.text||''),ls=finite(e.ls,0)*fs,syn=syntheticStroke(f.weight,f.faceWeight,fs);
 ctx.fillStyle='#000';ctx.textAlign=['left','right'].includes(e.align)?e.align:'center';ctx.textBaseline='middle';ctx.font=cssFont(f,f.faceWeight,fs);
 function write(text,x,y){if(syn>0){ctx.save();ctx.lineJoin='round';ctx.miterLimit=2;ctx.lineWidth=syn;ctx.strokeStyle='#000';ctx.strokeText(text,x,y);ctx.restore();}ctx.fillText(text,x,y);}
 try{ctx.letterSpacing=ls+'px';}catch{}
 if(Math.abs(finite(e.curve,0))>=1){
  try{ctx.letterSpacing='0px';}catch{}
  const chars=text.replace(/\n/g,' ').split(''),widths=chars.map(c=>ctx.measureText(c).width+ls),pos=arcLayout(widths,fs,e.curve);ctx.textAlign='center';
  pos.forEach((p,i)=>{ctx.save();ctx.translate(p.x,p.y);ctx.rotate(p.a);write(chars[i],0,0);ctx.restore();});
 }else{
  const lines=Array.isArray(e.lines)&&e.lines.length?e.lines.map(t=>e.smallcaps?String(t).toUpperCase():String(t)):text.split('\n'),lh=fs*1.12;
  lines.forEach((line,i)=>write(line,0,(i-(lines.length-1)/2)*lh));
 }
}
function artworkOf(e,recipe,options){
 if(e.svg)return e.svg;const id=e.logo||e.icon,entry=options.logos?.[id]||(recipe.logos||[]).find?.(l=>l.id===id)||recipe.logos?.[id];
 return typeof entry==='string'?entry:entry?.svg;
}
function elementBox(e,shape,face,box){
 const mm=dimensions(shape),size=finite(e.size,6)*1.2/mm.width*face.width,k=size/Math.max(box[2],box[3]);
 return {x:finite(e.x,.5)*face.width,y:finite(e.y,.5)*face.height,width:box[2]*k,height:box[3]*k,size,rotation:normRot(e.rot)};
}
// Live MTP's clean hex mask: removes the photographed white corners but keeps
// the natural edge. Square uses its measured face plus rounded surface clip.
function cleanHexMask(im,box){
 const iw=im.naturalWidth||im.width,ih=im.naturalHeight||im.height;
 const x=Math.round(box.x0*iw),y=Math.round(box.y0*ih),w=Math.max(2,Math.round((box.x1-box.x0)*iw)),h=Math.max(2,Math.round((box.y1-box.y0)*ih));
 const mask=canvas(w,h),ctx=mask.getContext('2d',{willReadFrequently:true});ctx.drawImage(im,x,y,w,h,0,0,w,h);
 try{
  const pixels=ctx.getImageData(0,0,w,h),p=pixels.data;
  for(let i=0;i<p.length;i+=4){const r=p[i],g=p[i+1],b=p[i+2],spread=Math.max(r,g,b)-Math.min(r,g,b);p[i+3]=r>=g&&g>=b&&r>90?(spread<=12?0:spread>=38?255:Math.round((spread-12)/26*255)):0;p[i]=p[i+1]=p[i+2]=0;}
  ctx.putImageData(pixels,0,0);
 }catch{ctx.clearRect(0,0,w,h);shapePath(ctx,'hexa',w,h);ctx.fillStyle='#000';ctx.fill();}
 return mask;
}
function drawHoles(ctx,shape,face,physical){
 const centers=shape==='carree'?[[15,15],[115,15]]:[[60,15]],sx=face.width/physical.width,sy=face.height/physical.height;
 ctx.save();ctx.translate(face.x,face.y);
 for(const [mmX,mmY] of centers){
  const x=mmX*sx,y=mmY*sy,r=2*sx;
  const grad=ctx.createRadialGradient(x,y-.5*sx,.05*sx,x,y,r);grad.addColorStop(0,'#f4f4f4');grad.addColorStop(.8,'#e3e3e3');grad.addColorStop(1,'#b4a99f');ctx.fillStyle=grad;ctx.beginPath();ctx.arc(x,y,r,0,Math.PI*2);ctx.fill();ctx.strokeStyle='rgba(13,13,13,.2)';ctx.lineWidth=.15*sx;ctx.stroke();
 }ctx.restore();
}
function create(options={}){
 const bgCache=new Map(),svgCache=new Map(),latest=new WeakMap();
 function photo(shape){const custom=options.photos?.[shape],base=PHOTOS[shape];return typeof custom==='string'?{...base,url:custom}:{...base,...custom};}
 function background(shape){
  const p=photo(shape),key=shape+'|'+p.url+'|'+JSON.stringify(p.box);if(!bgCache.has(key))bgCache.set(key,image(p.url,options.timeout).then(im=>({im,box:p.box,mask:shape==='hexa'?cleanHexMask(im,p.box):null})).catch(error=>{bgCache.delete(key);throw error;}));return bgCache.get(key);
 }
 function logo(raw){
  if(!raw)throw Error('Le dessin à graver est absent.');if(svgCache.has(raw))return svgCache.get(raw);
  const clean=inkSvg(raw),job=image('data:image/svg+xml;charset=utf-8,'+encodeURIComponent(clean.svg),options.timeout).then(im=>({im,viewBox:clean.viewBox})).catch(error=>{svgCache.delete(raw);throw error;});
  svgCache.set(raw,job);while(svgCache.size>8)svgCache.delete(svgCache.keys().next().value);return job;
 }
 async function ready(recipe){
  if(!recipe||!Array.isArray(recipe.elements))throw Error('La composition est absente.');
  const [bg,entries]=await Promise.all([background(shapeOf(recipe)),Promise.all(recipe.elements.map(async e=>{
   if(e.type==='text'){const font=fontDef(e,recipe,options);await loadFont(font,options.timeout);return {e,font};}
   if(e.type!=='logo'&&e.type!=='icon')throw Error('Élément de composition non pris en charge.');
   return {e,...await logo(artworkOf(e,recipe,options))};
  }))]);return {bg,entries};
 }
 function paint(target,recipe,resources,settings){
  const shape=shapeOf(recipe),im=resources.bg.im,g=geometry(shape,target.width,target.height,{...settings,box:resources.bg.box,imageWidth:im.naturalWidth||im.width,imageHeight:im.naturalHeight||im.height}),{face,physical}=g,ctx=target.getContext('2d');
  ctx.setTransform(1,0,0,1,0,0);ctx.clearRect(0,0,target.width,target.height);quality(ctx);
  if(settings.background){ctx.fillStyle=settings.background;ctx.fillRect(0,0,target.width,target.height);}
  if(settings.mode==='face'){
   const b=resources.bg.box;ctx.save();ctx.translate(face.x,face.y);shapePath(ctx,shape,face.width,face.height);ctx.clip();ctx.drawImage(im,b.x0*im.width,b.y0*im.height,(b.x1-b.x0)*im.width,(b.y1-b.y0)*im.height,0,0,face.width,face.height);ctx.restore();
  }else ctx.drawImage(im,g.image.x,g.image.y,g.image.width,g.image.height);
  const mask=canvas(target.width,target.height),mc=mask.getContext('2d');quality(mc);mc.save();mc.translate(face.x,face.y);
  // Artwork and text share the atelier's millimetre coordinates. Project both
  // axes onto the photographed face: using only its pixel width leaves a blank
  // top/bottom band on the hexagon, whose photo has a different aspect ratio.
  // This changes only the photo projection, never the source SVG or laser file.
  mc.scale(face.width/physical.width,face.height/physical.height);
  for(const slot of resources.entries){const e=slot.e,b=elementBox(e,shape,physical,slot.viewBox||[0,0,1,1]);mc.save();mc.translate(b.x,b.y);mc.rotate(b.rotation*Math.PI/180);
   if(e.type==='text')drawText(mc,e,slot.font,b.size);
   else mc.drawImage(slot.im,-b.width/2,-b.height/2,b.width,b.height);
   mc.restore();
  }mc.restore();
  // Same warm multiply colour and zero dilation as live guided engraving.
  mc.globalCompositeOperation='source-in';mc.fillStyle='#6f5331';mc.fillRect(0,0,mask.width,mask.height);mc.globalCompositeOperation='source-over';
  const ink=canvas(target.width,target.height),ic=ink.getContext('2d');quality(ic);ic.save();
  if(shape==='carree'||!resources.bg.mask){ic.translate(face.x,face.y);shapePath(ic,shape,face.width,face.height);ic.clip();ic.translate(-face.x,-face.y);}
  if('filter' in ic)ic.filter='blur('+Math.max(.3,face.width*.0004).toFixed(2)+'px)';ic.drawImage(mask,0,0);ic.restore();
  if(shape==='hexa'&&resources.bg.mask){ic.globalCompositeOperation='destination-in';ic.drawImage(resources.bg.mask,face.x,face.y,face.width,face.height);ic.globalCompositeOperation='source-over';}
  ctx.globalCompositeOperation='multiply';ctx.drawImage(ink,0,0);ctx.globalCompositeOperation='source-over';
  if(recipe.hole&&settings.holes!==false)drawHoles(ctx,shape,face,physical);
  return g;
 }
 async function render(target,recipe,settings={}){
  if(!target?.getContext)throw Error('Un canvas est nécessaire pour l’aperçu.');
  const token={};latest.set(target,token);
  const width=Math.max(1,Math.round(finite(settings.width,target.clientWidth||target.width||600))),height=Math.max(1,Math.round(finite(settings.height,width))),dpr=Math.max(1,Math.min(3,finite(settings.dpr,1)));
  // One immutable render request: fonts/images may finish after the visitor
  // changes shape or a caption. Never mix the old resources with new state.
  const snapshot={...recipe,elements:(recipe?.elements||[]).map(e=>({...e,lines:e.lines?.slice()})),fonts:recipe?.fonts?.map(f=>({...f}))};
  const resources=await ready(snapshot);if(latest.get(target)!==token)return {stale:true};
  const output=canvas(width*dpr,height*dpr),g=paint(output,snapshot,resources,settings);
  // Paint atomically once every resource is ready. Independent targets never
  // share scratch canvases, and a late image cannot overwrite a newer recipe.
  target.width=output.width;target.height=output.height;target.getContext('2d').drawImage(output,0,0);
  const face=Object.fromEntries(Object.entries(g.face).map(([k,v])=>[k,v/dpr]));
  return {canvas:target,stale:false,width,height,dpr,face,facePixels:g.face,physical:g.physical};
 }
 async function png(recipe,settings={}){const output=canvas(1,1);await render(output,recipe,{width:1200,height:1200,...settings,dpr:1});return output.toDataURL('image/png');}
 return {ready,render,png};
}
const api={create,geometry,dimensions,photos:PHOTOS,fonts:FONTS,arcLayout,elementBox,normRot,fontDef,syntheticStroke};if(typeof module==='object'&&module.exports)module.exports=api;else{root.PhotoRenderer=api;root.MTPPhotoEngine=api;}
})(typeof window==='object'?window:this);
